<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getUser } from '@/services/configurations/getUser'
import { getHistoricalByUser } from '@/services/historical/getHistoricalByUser'
import { getHistoricalByUserExcel } from '@/services/historical/getHistoricalByUserExcel'

export default {
  name: 'list-trash-user-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 24,
      vuexnamespace: 'historicalUser',
      headerUrl: 'trash/users/details',
      breadcrumbs: [
        { url: 'trash/users', name: i18n.t('trash.header') },
        { url: 'trash/users', name: i18n.t('trash.users') },
        { paths: ['Usuario'] },
      ],
      ExcelName: `${_.kebabCase(i18n.t('users.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  methods: {
    getParamsAux: function (data) {
      return { idUsuario: this.$route.params.id }
    },
    getParamsDetalleAux: function (data) {
      return { ...this.getParamsAux(data), borrado: true }
    },
    getDetalleAux: async function (params) {
      return await getUser(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByUserExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByUser(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
